import { Button, IconTypeMap } from '@mui/material'
import React from 'react';

interface Props {
  onClick?: () => void;
  title?: string;
  href?: string;
  icon?: any;
}

const StyledButton = ({ onClick, title, href, icon }: Props) => {
  return (
    <Button
    type="submit"
    variant="outlined"
    onClick={onClick}
    href={href}
    startIcon={icon}
    sx={{
      color: '#fff',
      marginTop: '2rem',
      border: '1px solid #fff',
      padding: '0 2rem',
      minHeight: '3rem',
      '&:hover': {
        backgroundColor: '#fff',
        borderColor: '#0a0a0a',
        color: '#0a0a0a',
        boxShadow: 'none',
      },
      '&:active': {
        boxShadow: 'none',
        backgroundColor: '#fff',
        color: '#0a0a0a',
        borderColor: '#0a0a0a',
      },
    }}
  >
    {title}
  </Button>        
)
}

export default StyledButton